var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      staticClass: "legal-modal",
      attrs: { scrollable: _vm.isMobile(_vm.$mq), legal: true, paywall: true }
    },
    [
      _c(
        "button",
        {
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("span", { staticClass: "b-sprite-global-close-black" })]
      ),
      _vm._v(" "),
      _c("h3", [_vm._v("About subscriptions")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    All amounts are billed in U.S. dollars at the beginning of each subscription period. You\n    authorize us to charge you for any sales or similar taxes that may be imposed on your\n    subscription payments. To change or cancel your subscription at any time, visit the Settings\n    page. If you cancel or change your subscription, we require a reasonable amount of time to\n    process the action. If you cancel, you'll enjoy subscription benefits until the end of your\n    then-current subscription commitment; then your subscription benefits will expire. However,\n    you will not be eligible for a prorated refund of any portion of the subscription fees paid\n    for the then-current subscription commitment. Please print a copy of this page and the\n    subscription page for your records. You shall be responsible for any foreign transaction fees\n    charged by your bank.\n  "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }